import { useEffect, useState } from 'react';
import { getRepositoriesV2 } from 'common/services/repositories.service';
import { useDebounceCallback } from '@react-hook/debounce';

export const useRepositoriesApi = ({
  pageSize = null,
  sensor_authorization_id,
  pageIndex,
  search = '',
  isOpen,
  repositories,
  extraParams = {}
} = {}) => {
  const [data, setData] = useState([]);
  const [totalRepos, setTotalRepos] = useState(0);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  const getRepos = useDebounceCallback(async () => {
    if (!isOpen) return;
    try {
      const offset = pageIndex * pageSize;
      const params = {
        limit: pageSize,
        offset,
        q: search,
        ...(extraParams && { ...extraParams })
      };
      setLoading(true);
      const { total_count, data } = await getRepositoriesV2({
        params,
        sensor_authorization_id
      });
      setLoading(false);
      setTotalRepos(total_count);
      setData(data);
    } catch (e) {
      setError(e);
      setData([]);
      setLoading(false);
      return [];
    }
  }, 700);

  useEffect(() => {
    getRepos();
  }, [isOpen, pageIndex, search, repositories, JSON.stringify(extraParams)]);

  return {
    data,
    setData,
    totalRepos,
    setTotalRepos,
    loading,
    setLoading,
    error,
    setError,
    getRepos
  };
};
